import clsx from "clsx";
import Icon from "../minicart/icon";
import React from "react";
import { getResizedSwatch } from "./util";

export default function MonogramSwatches({
  swatches,
  selectSwatch,
  containImages,
  stretchImages,
  shouldSelect = true,
}) {
  return (
    <div className="monogram-variant-selector">
      {swatches.map((swatch) => (
        <button
          key={`${swatch.imageSrc}-${swatch.alt}`}
          onClick={() => selectSwatch(swatch.value)}
          className={clsx("monogram-variant-selector__variant", {
            selected: swatch.selected && shouldSelect,
            "stretch-images": stretchImages,
            "contain-images": containImages,
          })}
        >
          {swatch.selected && shouldSelect && (
            <Icon id="checkmark" className="monogram-variant-selector__variant-check" />
          )}
          {swatch.cldSrc || swatch.imageSrc ? (
            <img
              alt={swatch.alt}
              loading="lazy"
              src={getResizedSwatch(swatch.cldSrc || swatch.imageSrc, 150)}
              style={{ backgroundColor: "var(--color-brand-light-pink)" }}
            />
          ) : (
            <span>{swatch.alt}</span>
          )}
        </button>
      ))}
    </div>
  );
}
